import React, { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { getSessionUser } from './common-utils'

interface AuthRouteProps {
  children: ReactNode
}

const AuthRoute: React.FC<AuthRouteProps> = ({ children }) => {
  const auth = getSessionUser()
  const token = auth?.token
  const location = useLocation()

  if (token) {
    return <Navigate to="/dashboard" state={{ from: location }} replace />
  }

  return <>{children}</>
}

export default AuthRoute
